import { cva } from 'class-variance-authority';

export const hamburgerMenuVariants = cva(
  [
    'flex',
    'flex-col',
    'justify-center',
    'items-center',
    'w-8',
    'h-8',
    'relative',
    'cursor-pointer',
    'duration-300',
    'focus:outline-none',
    'focus:ring-0',
    'focus-visible:outline-none',
    'focus-visible:ring-0',
    'active:outline-none',
    'active:ring-0',
    'focus-visible:ring-offset-0',
    'grayscale',
    'lg:hover:grayscale-0',
    'transition-all',
    'duration-300',
  ],
  {
    variants: {
      isOpen: {
        true: ['hamburger-menu-open'],
        false: [''],
      },
    },
    defaultVariants: {
      isOpen: false,
    },
  },
);
